/*
*
* Home actions
*
*/

import {
  HIDE_MODAL,
  SET_MODAL_OPTIONS,
  SHOW_MODAL,
  MODAL_SENDING
} from './constants';

export function setSending(value) {
  return {
    type: MODAL_SENDING,
    value
  };
}

export function hideModal() {
  return {
    type: HIDE_MODAL,
  };
}

export function setModalOptions(options) {
  return {
    type: SET_MODAL_OPTIONS,
    options,
  };
}

export function showModal(options) {
  return {
    type: SHOW_MODAL,
    options,
  };
}
